export default __webpack_public_path__ + "static/freshms-teaser2-desktop-c65270d5f2d182af7f971c1ace0517ca.png";